import Swal from "sweetalert2";

/**
 * El backend no bloquea períodos con fechas repetidas/superpuestas (solo el nombre debe ser
 * único, ver PeriodRequest::rules()), pero si ya existe otro período con las mismas fechas
 * exactas, PeriodController::duplicateDatesWarning() responde 409 con `requires_confirmation`
 * en vez de crear/guardar directamente.
 *
 * Esta función detecta esa respuesta y le pregunta al usuario si de verdad quiere continuar. Si
 * confirma, llama a `onConfirm` (que debe reintentar la petición con confirm_duplicate_dates:
 * true). Devuelve `true` si el error era esta advertencia (ya quedó manejado, no mostrar además
 * un toast de error genérico); `false` si es cualquier otro error y el caller debe manejarlo.
 */
export const confirmDuplicatePeriodDates = async (error, onConfirm) => {
  const data = error?.data;
  if (!data?.requires_confirmation) return false;

  const result = await Swal.fire({
    title: "Ya existe un período con este rango de fechas",
    text: data.error,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#9341af",
    cancelButtonColor: "#bbb",
    confirmButtonText: "Sí, crear igual",
    cancelButtonText: "Cancelar",
  });

  if (result.value) {
    await onConfirm();
  }

  return true;
};

export default confirmDuplicatePeriodDates;
